import { createStore, get, set } from "idb-keyval";
const DB_NAME = "rialtic-collaboration";
const STORE_NAME = "documents";
const SNAPSHOT_VERSION = 1;
export const createIndexedDbPersistence = (key) => {
  const store = createStore(DB_NAME, STORE_NAME);
  return {
    async load() {
      const record = await get(key, store);
      if (!record || record.version !== SNAPSHOT_VERSION) return null;
      return record.snapshot;
    },
    save(snapshot) {
      return set(key, { version: SNAPSHOT_VERSION, snapshot }, store);
    }
  };
};
